<div
  (keydown.escape)="handlingEscape($event)"
  (keydown.tab)="handlingTab($event)"
  *ngIf="_open"
  class="idp-simple-modal"
>
  <div
    [ngClass]="getDialogModalClass(modalStyle, scrollModal)"
    class="idp-dialog"
    data-test-modal-wrapper="true"
  >
    <div
      #simpleModalRef
      [attr.aria-label]="getAriaLabel(displayProperties, modalTitle)"
      data-cy="modalTitle"
      [attr.role]="roleType"
      [attr.tabindex]="displayProperties && displayProperties.focus ? 0 : -1"
      class="
      idp-simple-modal__body
      idp-dialog__body
      idp-dialog__body--{{ height }}-height"
      data-test-modal-body="true"
    >
      <div
        *ngIf="displayProperties?.header"
        [ngClass]="{
          'idp-simple-modal__flex-direction--unset': !showCloseIcon
        }"
        class="idp-dialog__header header--{{
          headerStyle
        }} closeOnBackgroundClick"
      >
        <button
          (click)="close($event)"
          (keydown.shift.tab)="tabPrevious($event)"
          *ngIf="showCloseIcon && !showBackButton"
          aria-label="Close Dialog"
          class="idp_dialog__close idp_dialog__close--{{ headerStyle }} "
          data-cy="closeModalBtn"
          data-test-dialog-close="true"
          type="button"
        >
          <i
            [ngClass]="{ 'idp-white-close-icon': whiteCloseIcon }"
            aria-hidden="true"
            class="idp-close-icon"
          ></i>
        </button>

        <button
          (click)="close($event)"
          (keydown.shift.tab)="tabPrevious($event)"
          *ngIf="showCloseIcon && showBackButton"
          aria-label="Close Dialog"
          class="idp_dialog__close idp_dialog__close--{{
            headerStyle
          }} close_button"
          data-cy="closeModalBtn"
          data-test-dialog-close="true"
          type="button"
        >
          <i
            [ngClass]="{ 'idp-white-close-icon': whiteCloseIcon }"
            aria-hidden="true"
            class="idp-close-icon"
          ></i>
        </button>
        <h2
          *ngIf="modalStyle !== 'advisory' && showBackButton"
          [attr.data-test-modal-header]="modalTitle"
          [id]="id"
          [attr.data-cy]="'idp-dialog-header-modal-title' + id"
          [ngClass]="[customClass]"
          [innerHTML]="modalTitle"
          class="idp-dialog__header--title modal_header"
        ></h2>
        <h2
          *ngIf="modalStyle !== 'advisory' && !showBackButton"
          [attr.data-test-modal-header]="modalTitle"
          [id]="id"
          [attr.data-cy]="'idp-dialog-modal-title' + id"
          [ngClass]="[customClass]"
          [innerHTML]="modalTitle"
          class="idp-dialog__header--title"
        ></h2>
        <h2
          *ngIf="modalStyle === 'advisory'"
          class="modal_header idp-dialog__header--title header--light"
          id="idp-dialog-name"
          [attr.data-cy]="'idp-dialog-name' + id"
        >
          {{ modalTitle }}
        </h2>
        <button
          *ngIf="showBackButton"
          aria-label="back"
          class="exit-button backBtn"
          type="button"
          (click)="close($event)"
          [id]="'exit-button'"
          [attr.data-cy]="'exit-button'"
        >
          <span
            aria-hidden="true"
            data-font-icon="&#xe9a3;"
            aria-pressed="true"
          ></span>
        </button>
      </div>
      <div
        *ngIf="message"
        class="idp_dialog__message"
        [id]="'idp-dialog-message'"
        [attr.data-cy]="'idp-dialog-message'"
      >
        <p class="idp_dialog__message--message-body">{{ message }}</p>
      </div>
      <ng-container *ngIf="!displayProperties?.header && showCloseIcon">
        <button
          (click)="close($event)"
          aria-label="Close Dialog"
          class="idp_dialog__close--floating"
          type="button"
          [id]="'close-button'"
          [attr.data-cy]="'close-button'"
        >
          <i aria-hidden="true" class="idp-close-icon"></i>
        </button>
      </ng-container>
      <div
        *ngIf="modalStyle === 'advisory' || modalStyle === 'autoheight'"
        [ngClass]="{ 'm-0': headerStyle === 'light' }"
        class="idp-dialog__header-divider header-divider--border-bottom"
      ></div>
      <div [attr.tabindex]="tabIndex" [ngClass]="setModalClasses()">
        <ng-content></ng-content>
      </div>
      <div
        *ngIf="displayProperties?.footer && showFooter"
        [ngClass]="{ 'cancel-submit-btn': showAllBtn }"
        class="idp-dialog__footer idp-dialog__footer--align-left"
      >
        <idp-button
          (keydown.tab)="focus($event)"
          (notify)="close($event)"
          *ngIf="showCloseButton"
          [ariaLabel]="ariaLabelClose"
          [ariaPopup]="openWindow"
          [label]="cancelButtonTitle"
          [size]="cancelButtonSize"
          [type]="modalType"
          class="idp-btn-cancel"
          [id]="'cancel-button'"
          [attr.data-cy]="'cancel-button'"
        ></idp-button>
        <idp-button
          (keydown.tab)="focus($event)"
          (notify)="continue($event)"
          *ngIf="showContinue"
          [ariaLabel]="ariaLabelClose"
          [ariaPopup]="openWindow"
          [label]="cancelButtonTitle"
          [size]="cancelButtonSize"
          [type]="modalType"
          class="idp-btn-cancel"
          [id]="'cancel-button'"
          [attr.data-cy]="'cancel-button'"
        ></idp-button>
        <idp-button
          (keydown.tab)="focus($event)"
          (notify)="ctaEvent($event)"
          *ngIf="showSubmitButton"
          [ariaLabel]="ariaLabelSubmit"
          [ariaPopup]="openWindow"
          [label]="submitButtonTitle"
          [size]="submitButtonSize"
          [type]="submitButtonStyle"
          class="idp-btn-submit"
          [id]="'submit-button'"
          [attr.data-cy]="'submit-button'"
        ></idp-button>
      </div>
    </div>
  </div>
  <div
    (click)="outsideModal($event)"
    *ngIf="loadBackground"
    class="idp-dialog-background"
    data-test-dialog-background="true"
  ></div>
</div>
